import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=2b94cfb2&scoped=true&"
import script from "./UserAgreement.vue?vue&type=script&lang=js&"
export * from "./UserAgreement.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/zx-agreement.css?vue&type=style&index=0&id=2b94cfb2&prod&scoped=true&lang=css&"
import style1 from "./UserAgreement.vue?vue&type=style&index=1&id=2b94cfb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b94cfb2",
  null
  
)

export default component.exports